import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import { ExportCustomerForecastRateResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';

/**
 * 内示正答率をエクスポートするUseCase
 */
export class ExportForecastAccuracyRateUseCase {
  private repository: ICustomerForecastRepository;

  /**
   * コンストラクタ
   * @param repository - 内示リポジトリ
   */
  constructor(repository: ICustomerForecastRepository) {
    this.repository = repository;
  }

  /**
   * 内示正答率をエクスポートする
   * @param forecastForReceiptId - 受領用内示ID
   * @param startYear - 開始年
   * @param startMonth - 開始月
   * @param endYear - 終了年
   * @param endMonth - 終了月
   * @param receiveYear - 表示年
   * @param receiveMonth - 表示月
   * @param language - 出力言語（ja: 日本語、en: 英語）
   */
  public Execute = async (
    forecastForReceiptId: string,
    startYear: number,
    startMonth: number,
    endYear: number,
    endMonth: number,
    receiveYear: number,
    receiveMonth: number,
    language: string
  ): Promise<INetworkResult<ExportCustomerForecastRateResponseAllOfResult, Error>> => {
    try {
      const result = await this.repository.exportForecastRate(
        forecastForReceiptId,
        startYear,
        startMonth,
        endYear,
        endMonth,
        receiveYear,
        receiveMonth,
        language
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('内示正答率のエクスポートに失敗しました'),
        },
      };
    }
  };
}
